export default {
	a: ["1:-xx-",
			"2:x--x",
			"1:xxxx",
			"1:x--x"],
	b: ["1:xxx",
			"1:x--x", 
			 "1:xxx",
			"1:x--x",
			"1:xxx"],
	c: ["1:-xxx",
			"3:x",
		    "1:-xxx"],
	d: ["1:xxx",
			"3:x--x",
			"1:xxx"],
	e: ["1:xxxx",
		"1:x",
		"1:xxx",
		"1:x",
		"1:xxxx"],
	f: ["1:xxxx",
		  "1:x",
		  "1:xxx",
		  "1:x",
		"1:x"],
	g: ["1:-xxx",
			"1:x",
		  "1:x-xx",
			"1:x--x",
			"1:-xxx"],
	h: ["2:x--x",
			"1:xxxx",
			"2:x--x"],	
	i: ["1:xxx",
			"3:-x",
			"1:xxx"],
	j: ["3:---x",
		  "1:x--x",
		  "1:-xx"],
	k: ["1:x--x",
			"1:x-x",
			"1:xx",
			"1:x-x",
			"1:x--x"],
	l: ["4:x",
			"1:xxxx"],
	m: ["1:x---x",
			"1:xx-xx",
			"1:x-x-x",
			"2:x---x"],
	n: ["1:x--x",
			"1:x--x",
			"1:xx-x",
			"1:x-xx",
			"1:x--x"],
	o: ["1:-xx",
			"3:x--x",
		  "1:-xx"],
	p: ["1:xxx",
			"1:x--x",
			"1:xxx",
			"2:x"],
	q: ["1:-xx",
		"3:x--x",
		 "1:-xxxx"],
	r: ["1:xxx",
			"1:x--x",
			"1:xxx",
			"2:x--x"],
	s: ["1:-xxx",
			"1:x",
			"1:-xx-",
			"1:---x",
			"1:xxx"],
	t: ["1:xxxxx",
			"4:--x"],
	u: ["4:x--x",
		  "1:-xx"],
	v: ["3:x---x",
		  "1:-x-x",
			"1:--x"],
	w: ["2:x---x",
			"1:x-x-x",			 
			"1:xx-xx",			 
		  "1:x---x"],
	x: ["1:x---x",
			"1:-x-x-",
			"1:--x",
			"1:-x-x",
			"1:x---x"],
	y: ["2:x---x",
			"1:-x-x",
			"2:--x"],
	z: ["1:xxxx",
			"1:--x",
			"1:-x",
			"1:x",
			"1:xxxx"],
	1: ["1:-x",
			"1:xx",
			"3:-x"],
	2: ["1:xxxx",
		  "1:---x",
		  "1:xxxx",
		  "1:x",
		"1:xxxx"],
	3: ["1:xxxx",
		  "1:---x",
		  "1:xxxx",
		  "1:---x",
		"1:xxxx"],
	4: ["2:x--x",
		  "1:xxxx",
		  "2:---x"],
	5: ["1:xxxx",
		  "1:x",
		  "1:xxxx",
		  "1:---x",
			"1:xxxx"],
	6: ["1:xxxx",
		  "1:x",
		  "1:xxxx",
		  "1:x--x",
			"1:xxxx"],
	7: ["1:xxxx",
		  "1:---x",
		  "1:--x",
		  "2:-x"],
	8: ["1:xxxx",
		  "1:x--x",
		  "1:xxxx",
		  "1:x--x",
		"1:xxxx"],
	9: ["1:xxxx",
		  "1:x--x",
			"1:xxxx",
			"1:---x",
			"1:xxxx"],
	0: ["1:xxxx",
		  "3:x--x",
			"1:xxxx"],
	"!": ["3:x",
				"1:-",
				"1:x"],
	":": ["1:-",
				"1:x",
				"1:-",
				"1:x"],
	"(": ["1:-x",
			"3:x",
		  "1:-x"],
	")": ["1:x",
			"3:-x",
		  "1:x"],
	"-": ["2:-",
				"1:xxx"],
	"?": ["1:xxx",
			"1:---x",
			"1:-xx",
			"1:-",
			"1:-x"],
	//.@#%&*$"' smile
	 " ": ["1:-"],
	 ".": ["4:-",
				 "1:x"],
	  //heart
	 "{": ["1:-xx-xx-",
				 "1:xxxxxxx",
				 "1:-xxxxx",
				 "1:--xxx",
				 "1:---x"],
	"@": ["1:-xxx-",
			"1:x-xxx",
			"1:x-xx-",
			"1:x",
			"1:-xxx"],
	"#": ["1:-x-x",
				"1:xxxxx",
			  "1:-x-x",
				"1:xxxxx",
				"1:-x-x"],
	"&":   ["1:-",
			"1:-x-",
			"1:xxx",
			"1:-x-",
			"1:-"],
	"+":   ["1:-",
			"1:-x-",
			"1:xxx",
			"1:-x-",
			"1:-"],
}